<div mat-dialog-title>
  <h2>Term history</h2>

  <button
    [mat-dialog-close]="false"
    matIconButton
    class="close-btn">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (!isLoading) {
    <ng-container>
      <table
        mat-table
        [dataSource]="dataSource">
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Date
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.timestamp | date: 'dd MMM yy' }}
          </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th
            mat-header-cell
            *matHeaderCellDef>
            Action
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ getTermAction(row.action) }}
          </td>
        </ng-container>

        <!-- User(By) Column -->
        <ng-container matColumnDef="by">
          <th
            mat-header-cell
            *matHeaderCellDef>
            By
          </th>
          <td
            mat-cell
            *matCellDef="let row">
            {{ row.user.firstName + ' ' + row.user.lastName }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </ng-container>
  } @else {
    <mat-spinner [diameter]="24"></mat-spinner>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    matButton
    [mat-dialog-close]="false">
    Close
  </button>
</mat-dialog-actions>
